import { render, staticRenderFns } from "./KanbanBoardProductionOrderItemListLine.vue?vue&type=template&id=6bf3779a"
import script from "./KanbanBoardProductionOrderItemListLine.vue?vue&type=script&lang=js"
export * from "./KanbanBoardProductionOrderItemListLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports